'use strict';
/*!
 * Post and News period picker
 *
 * @package krobot
 * @deps jquery
 */

const $ = jQuery;

$( '.news-navigation__select-wrap select' ).change( function() {
	if ( $( this ).val() !== '' ) {
		window.location.href = $( this ).val();
	}
} );
